<template>
  <div class="container">
    <div class="head_bg">
      <comm-head></comm-head>
      <div class="head_con">
        <img src="../assets/images/img_john.png" alt />
        <div></div>
        <div>
          <el-carousel ref="carousel" indicator-position="none" :interval="5000" arrow="never">
            <el-carousel-item>
              <div class="title_carousel_item">我们提倡的价值观是：谦（满招损谦受益）、诚(不信不立 不诚不行）、善（上善若水 泽被万物）、思（用心创造）</div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="title_carousel_item">我们的使命是：Do my best，Make it easy</div>
              <div class="title_carousel_item">我们的愿景：Change myself Change the world（Even a little）</div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="introduce">
      <div>
        <h1>公司介绍</h1>
        <div>
          <div>
            <p>杭州多麦电子商务股份有限公司，成立于2010年8月，互联网精准营销的领军企业。</p>
            <p>我们为全球知名品牌提供一站式营销解决方案，包括品牌传播、互动传播、内容传播及ROI战略合作等；目前服务全球800+知名电商平台、服饰、奢侈品、快销品、数码、金融、教育、泛娱乐等各领域知名品牌。</p>
            <p>我们通过自主研发的精准营销技术、大数据技术，实现基于广告预算、地域和目标用户画像的新媒体程序化广告投放，为微软、京东等全球新零售领域的上千家标杆企业或平台提供互联网新媒体效果营销服务。</p>
          </div>
          <img src="../assets/images/jieshao_img.png" alt />
        </div>
      </div>
    </div>
    <div class="honor">
      <div>
        <h1>公司荣誉</h1>
        <div>
          <el-carousel height="254px" indicator-position="none" :interval="5000" arrow="never">
            <el-carousel-item>
              <div class="carousel_item">
                <img src="../assets/images/honor_1.png" alt />
                <img src="../assets/images/honor_2.png" alt />
                <img src="../assets/images/honor_3.png" alt />
                <img src="../assets/images/honor_4.png" alt />
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel_item">
                <img src="../assets/images/honor_5.png" alt />
                <!-- <img src="../assets/images/honor_6.png" alt /> -->
                <img src="../assets/images/honor_7.png" alt />
                <img src="../assets/images/honor_8.png" alt />
                <img src="../assets/images/honor_9.png" alt />
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel_item">
                <img src="../assets/images/honor_10.png" alt />
                <img src="../assets/images/honor_11.png" alt />
                <img src="../assets/images/honor_12.png" alt />
                <img src="../assets/images/honor_13.png" alt />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <foot-cpright></foot-cpright>
  </div>
</template>

<script>
import commHead from "@/components/comm-head.vue";
import footCpright from "@/components/foot-cpright.vue";
export default {
  data() {
    return {};
  },
  components: {
    commHead,
    footCpright
  }
};
</script>

<style lang="scss" scoped>
.container {
  overflow-y: auto;
  & .head_bg {
    height: 480px;
    background-image: url("../assets/images/banner_gsjs.png");
    & .head_con {
      width: 1200px;
      height: 392px;
      position: relative;
      margin: 0 auto;
      & img {
        width: 250px;
        height: 350px;
        display: block;
        position: absolute;
        top: 42px;
        animation: head_img_opac 5s;
      }
      & > div:nth-child(2) {
        width: 38px;
        height: 30px;
        position: absolute;
        top: 120px;
        left: 282px;
        opacity: 0.64;
        font-family: Arial-BoldMT;
        font-size: 88px;
        color: #ffffff;
        letter-spacing: 0;
        animation: textcomein_1 2s;
        background-image: url("../assets/images/fuhao.png");
        background-repeat: no-repeat;
        background-size: 100%;
      }
      & > div:last-child {
        width: 809px;
        position: absolute;
        top: 144px;
        left: 342px;
        color: #fff;
        animation: textcomein 2s;
        & /deep/ .title_carousel_item {
          font-family: PingFangSC-Regular;
          font-size: 28px;
          color: #ffffff;
          letter-spacing: 0;
          line-height: 40px;
          margin-bottom: 18px;
        }
      }
    }
  }
  & .introduce {
    padding: 64px 0px 80px;
    background-color: #fff;
    min-width: 1280px;
    & > div {
      width: 1200px;
      margin: 0 auto;
      & h1 {
        margin-bottom: 32px;
        line-height: 48px;
      }
      & > div {
        height: 254px;
        display: flex;
        & div {
          flex: 1;
          & p {
            font-size: 18px;
            color: #666666;
            line-height: 32px;
            margin-bottom: 16px;
          }
          & p:last-child {
            margin-bottom: 0px;
          }
        }
        & img {
          width: 420px;
          height: 254px;
          margin-left: 63px;
        }
      }
    }
  }

  & .honor {
    padding-bottom: 80px;
    background-color: #fff;
    min-width: 1280px;
    & > div {
      width: 1200px;
      margin: 0 auto;
      & h1 {
        margin-bottom: 32px;
        line-height: 48px;
      }
      & > div {
        height: 233px;
        & .carousel_item {
          width: 100%;
          height: 100%;
          display: flex;

          & > img {
            width: 277px;
            height: 233px;
            margin-right: 30px;
          }
          & > img:last-child {
            margin-right: 0px;
          }
        }
      }
    }
  }
}

@keyframes textcomein {
  0% {
    opacity: 0;
    top: 0px;
  }
  100% {
    opacity: 1;
    top: 144px;
  }
}
@keyframes textcomein_1 {
  0% {
    opacity: 0;
    top: 0px;
  }
  100% {
    opacity: 0.64;
    top: 120px;
  }
}
</style>
